import { isEn } from "project-config/utils/env";
import duration from "dayjs/plugin/duration";
import dayjs from "dayjs";
dayjs.extend(duration);

export const THREE_MOUTH = 3600 * 1000 * 24 * 92;
export const ONE_WEEK = 3600 * 1000 * 24 * 7;
export const ONE_SECOND_SHORT = 24 * 3600 * 1000 - 1000;

export function getBeijingTimeZone(date: Date) {
  const BeiJingTimeZone = 8 * 60 * 60 * 1000;
  const offsetTime = new Date().getTimezoneOffset() * 60 * 1000; // 本地时间和格林威治的时间差，单位为分钟
  return new Date(+date + BeiJingTimeZone + offsetTime);
}

export function dateTimeFormater(date: Date) {
  const year = date.getFullYear();
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const day = ("0" + date.getDate()).slice(-2);
  const hour = ("0" + date.getHours()).slice(-2);
  const minutes = ("0" + date.getMinutes()).slice(-2);
  const seconds = ("0" + date.getSeconds()).slice(-2);
  const milliSeconds = ("00" + date.getSeconds()).slice(-3);
  return `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`;
}

export function dateFormater(date: Date | number) {
  if (date === 0) {
    return "——";
  } else if (!date) {
    return "";
  } else {
    const targetDate = new Date(date);
    const year = targetDate.getFullYear();
    const month = ("0" + (targetDate.getMonth() + 1)).slice(-2);
    const day = ("0" + targetDate.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }
}

export function getTimeZone() {
  function getTimeNumber(time: number) {
    return Math.floor(Math.abs(time)).toString().padStart(2, "0");
  }

  var offset = new Date().getTimezoneOffset();
  return `${offset < 0 ? "+" : "-"}${getTimeNumber(
    offset / 60
  )}:${getTimeNumber(offset % 60)}`;
}

export const hoursFormatter = (value: number | null) => {
  if (value === null) return;
  return parseFloat(value.toString()) / 3600;
};

export const timeFormatter = (value: number, type?: number) => {
  const enI18n = {
    hours: "h",
    minutes: "m",
    seconds: "s",
  };
  const zhI18n = {
    hours: "小时",
    minutes: "分",
    seconds: "秒",
  };

  const getTranslateNsT = (local: "zh" | "en") => {
    return (key: string) =>
      ({
        zh: zhI18n,
        en: enI18n,
      }[local][key] || "");
  };
  const t = getTranslateNsT(isEn() ? "en" : "zh");

  if (value !== null && value !== undefined) {
    let minutes = 0;
    let seconds = 0;
    let hours = 0;
    if (type === 1) {
      // value is million second
      value /= 1000; // million seconds should be computed to seconds
    }
    hours = Math.floor(value / 3600);
    let remainSeconds = value - hours * 3600;
    if (remainSeconds > 60 || remainSeconds === 0) {
      minutes = Math.floor(remainSeconds / 60);
      remainSeconds = value - hours * 3600 - minutes * 60;
      if (remainSeconds > 0) {
        seconds = remainSeconds;
      }
    } else {
      seconds = remainSeconds;
    }
    const hoursStr = hours > 0 ? `${hours}${t("hours")}` : "";
    const minutesStr = minutes > 0 ? `${minutes}${t("minutes")}` : "";
    const secondsStr = seconds > 0 ? `${seconds}${t("seconds")}` : "";
    return `${hoursStr}${minutesStr}${secondsStr}`;
  }
  return "0";
};

export function getDateAfterDay(date: Date, afterDay: number): Date {
  return new Date(new Date(date).setDate(new Date(date).getDate() + afterDay));
}

export function getToday() {
  const now = new Date();
  return new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
}

export function getStartDate(v: Date | string) {
  const vDate = new Date(v);
  const result = new Date(
    vDate.getFullYear(),
    vDate.getMonth(),
    vDate.getDate()
  );
  return result;
}

export function getEndDate(v: Date | string) {
  const vDate = new Date(v);
  const result = new Date(
    vDate.getFullYear(),
    vDate.getMonth() + 1,
    vDate.getDate()
  );
  return result;
}

export function getDateFormatYMD2(date: Date) {
  return `${[
    date.getFullYear(),
    (date.getMonth() + 1).toString().padStart(2, "0"),
    date.getDate().toString().padStart(2, "0"),
  ].join("-")}`;
}

export const monthDateFormatter = (value: number) => {
  if (value !== null && value !== undefined) {
    if (value === 0) {
      return "——";
    }
    const date = new Date(value);
    const datestr = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
    const monthstr =
      date.getMonth() >= 9 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
    const minutesStr =
      date.getMinutes() > 9 ? date.getMinutes() : `0${date.getMinutes()}`;
    const secondsStr =
      date.getSeconds() > 9 ? date.getSeconds() : `0${date.getSeconds()}`;
    return `${monthstr}-${datestr} ${date.getHours()}:${minutesStr}:${secondsStr}`;
  }
  return "";
};

export const dateformatter = (value: number) => {
  if (value !== null && value !== undefined) {
    if (value === 0) {
      return "——";
    }
    const date = new Date(value);
    const datestr = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
    const minutesStr =
      date.getMinutes() > 9 ? date.getMinutes() : `0${date.getMinutes()}`;
    const secondsStr =
      date.getSeconds() > 9 ? date.getSeconds() : `0${date.getSeconds()}`;
    return `${date.getFullYear()}-${
      date.getMonth() + 1
    }-${datestr} ${date.getHours()}:${minutesStr}:${secondsStr}`;
  }
  return "";
};

export const hoursMinutesformatter = (value: number) => {
  if (value !== null && value !== undefined) {
    const date = new Date(value);
    const hoursStr =
      date.getHours() > 9 ? date.getHours() : `0${date.getHours()}`;
    const minutesStr =
      date.getMinutes() > 9 ? date.getMinutes() : `0${date.getMinutes()}`;
    return `${hoursStr}:${minutesStr}`;
  }
  return "";
};

export const formatDuration = (seconds: number) => {
  const timeLeft = dayjs.duration(seconds, "seconds");
  const days = timeLeft.days();
  const hours =
    timeLeft.hours() > 9 ? timeLeft.hours() : `0${timeLeft.hours()}`;
  const minutes =
    timeLeft.minutes() > 9 ? timeLeft.minutes() : `0${timeLeft.minutes()}`;
  const secs =
    timeLeft.seconds() > 9 ? timeLeft.seconds() : `0${timeLeft.seconds()}`;

  return `${days}天 ${hours}: ${minutes}: ${secs}`;
};

export const getHoursFromSeconds = (seconds: number) => {
  const hours = seconds / 3600;
  return parseFloat(hours.toFixed(2));
};
